import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/location/list/locationListExporterFields';
import selectors from 'src/modules/location/list/locationListSelectors';
import LocationService from 'src/modules/location/locationService';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'LOCATION_LIST';

const locationListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  TEMPLATES_FETCH_STARTED: `${prefix}_TEMPLATES_FETCH_STARTED`,
  TEMPLATES_FETCH_SUCCESS: `${prefix}_TEMPLATES_FETCH_SUCCESS`,
  TEMPLATES_FETCH_ERROR: `${prefix}_TEMPLATES_FETCH_ERROR`,

  doFetchTemplates: () => async (dispatch) => {
    try {
      dispatch({
        type: locationListActions.TEMPLATES_FETCH_STARTED,
      });

      const rows = await LocationService.listTemplates();

      dispatch({
        type: locationListActions.TEMPLATES_FETCH_SUCCESS,
        payload: rows || [],
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: locationListActions.TEMPLATES_FETCH_ERROR,
      });
    }
  },

  doChangeSelected(payload) {
    return {
      type: locationListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: locationListActions.RESETED,
    });

    dispatch(locationListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: locationListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await LocationService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.location.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: locationListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: locationListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort:
    (pagination, sorter) => async (dispatch, _getState) => {
      dispatch({
        type: locationListActions.PAGINATION_CHANGED,
        payload: pagination,
      });

      dispatch({
        type: locationListActions.SORTER_CHANGED,
        payload: sorter,
      });

      dispatch(locationListActions.doFetchCurrentFilter());
    },

  doFetchCurrentFilter:
    () => async (dispatch, getState) => {
      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        locationListActions.doFetch(
          filter,
          rawFilter,
          true,
        ),
      );
    },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: locationListActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });

        const response = await LocationService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: locationListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: locationListActions.FETCH_ERROR,
        });
      }
    },

  doCopyFetch:
    (filter?, rawFilter?, _keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        const response = await LocationService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: locationListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: locationListActions.FETCH_ERROR,
        });
      }
    },
};

export default locationListActions;
